import React from "react";
import { api } from "~/utils/api";
import { useUser } from "~/modules/user/hooks/useUser";
import { Chart } from "~/modules/charts/types";

// // // //

interface State {
    loading: boolean;
    not_found: boolean;
    chart: Chart | null;
}

/**
 * ChartFetcher
 * Fetches a single chart by slug via the tRPC API and exposes it via
 * props.children render prop.
 */
export function ChartFetcher(props: {
    chartSlug: string;
    children: (state: State) => React.ReactNode;
}) {
    const { user } = useUser();
    const chartReq = api.charts.getBySlug.useQuery({
        slug: props.chartSlug,
        organizationID: user.organization.id,
    });

    const chart = chartReq.data ?? null;

    return (
        <React.Fragment>
            {props.children({
                loading: chartReq.isLoading,
                not_found: !chartReq.isLoading && chart === null,
                chart,
            })}
        </React.Fragment>
    );
}
